import IFrameCode from '@/components/content-types/iFrameCode';
import LinkNoPrefetch from '@/components/link-noprefetch';

function Demo({ attrs, node }) {
    const data = attrs?.data ?? node?.attrs?.data;
    const framecode = data?.framecode ?? data?.frameCode;
    if (!framecode) return null;

    const { thumbnail, title, description, category, duration, urlTitle } = data;

    return (
        <div className="not-prose my-8">
            <div className="mb-4 flex flex-col gap-2">
                {(category || duration) && (
                    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-fuschia-700">
                        {category && <span>{category}</span>}
                        {category && duration && <span className="text-blue-300">•</span>}
                        {duration && <span className="text-blue-500">{duration}</span>}
                    </div>
                )}
                {title && (
                    <h3 className="m-0 text-2xl font-semibold tracking-tight text-blue-700">
                        {title}
                    </h3>
                )}
                {description && <p className="m-0 text-sm text-blue-500">{description}</p>}
            </div>

            <IFrameCode
                frameCode={framecode}
                thumbnail={thumbnail}
                useFrame
                buttonLabel="Launch Tour"
                maxHeight={500}
            />

            {urlTitle && (
                <div className="mt-3 text-right">
                    <LinkNoPrefetch
                        href={`/demo-center/${urlTitle}`}
                        className="text-sm font-semibold text-primary hover:underline">
                        Open full demo →
                    </LinkNoPrefetch>
                </div>
            )}
        </div>
    );
}

export default Demo;
